import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getMonitoringWorkflows = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/monitoring/workflows`
  return apiGet({ url, token, params })
}

export default function useMonitoringWorkflows({
  params = {},
  options = {}
} = {}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id }
  const queryFn = () => getMonitoringWorkflows(token, mergedParams)
  const queryKey = ['monitoring-workflows', mergedParams]

  return useQuery(queryKey, queryFn, {
    enabled: Boolean(municipality_id),
    ...options
  })
}
